import { _ as _assert_this_initialized } from "@swc/helpers/_/_assert_this_initialized";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
import { State } from "../../State";
import { EventTypes } from "../interfaces";
import GestureHandler from "./GestureHandler";
var DEFAULT_MAX_DURATION_MS = 500;
var DEFAULT_MAX_DELAY_MS = 500;
var DEFAULT_NUMBER_OF_TAPS = 1;
var DEFAULT_MIN_NUMBER_OF_POINTERS = 1;
var TapGestureHandler = /*#__PURE__*/ function(GestureHandler) {
    "use strict";
    _inherits(TapGestureHandler, GestureHandler);
    var _super = _create_super(TapGestureHandler);
    function TapGestureHandler() {
        _class_call_check(this, TapGestureHandler);
        var _this;
        _this = _super.apply(this, arguments);
        _define_property(_assert_this_initialized(_this), "maxDeltaX", Number.MIN_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "maxDeltaY", Number.MIN_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "maxDistSq", Number.MIN_SAFE_INTEGER);
        _define_property(_assert_this_initialized(_this), "maxDurationMs", DEFAULT_MAX_DURATION_MS);
        _define_property(_assert_this_initialized(_this), "maxDelayMs", DEFAULT_MAX_DELAY_MS);
        _define_property(_assert_this_initialized(_this), "numberOfTaps", DEFAULT_NUMBER_OF_TAPS);
        _define_property(_assert_this_initialized(_this), "minNumberOfPointers", DEFAULT_MIN_NUMBER_OF_POINTERS);
        _define_property(_assert_this_initialized(_this), "currentMaxNumberOfPointers", 1);
        _define_property(_assert_this_initialized(_this), "startX", 0);
        _define_property(_assert_this_initialized(_this), "startY", 0);
        _define_property(_assert_this_initialized(_this), "offsetX", 0);
        _define_property(_assert_this_initialized(_this), "offsetY", 0);
        _define_property(_assert_this_initialized(_this), "lastX", 0);
        _define_property(_assert_this_initialized(_this), "lastY", 0);
        _define_property(_assert_this_initialized(_this), "waitTimeout", void 0);
        _define_property(_assert_this_initialized(_this), "delayTimeout", void 0);
        _define_property(_assert_this_initialized(_this), "tapsSoFar", 0);
        return _this;
    }
    _create_class(TapGestureHandler, [
        {
            key: "init",
            value: function init(ref, propsRef) {
                _get(_get_prototype_of(TapGestureHandler.prototype), "init", this).call(this, ref, propsRef);
            }
        },
        {
            key: "updateGestureConfig",
            value: function updateGestureConfig(_param) {
                var _param_enabled = _param.enabled, enabled = _param_enabled === void 0 ? true : _param_enabled, props = _object_without_properties(_param, [
                    "enabled"
                ]);
                _get(_get_prototype_of(TapGestureHandler.prototype), "updateGestureConfig", this).call(this, _object_spread({
                    enabled: enabled
                }, props));
                if (this.config.numberOfTaps !== undefined) {
                    this.numberOfTaps = this.config.numberOfTaps;
                }
                if (this.config.maxDurationMs !== undefined) {
                    this.maxDurationMs = this.config.maxDurationMs;
                }
                if (this.config.maxDelayMs !== undefined) {
                    this.maxDelayMs = this.config.maxDelayMs;
                }
                if (this.config.maxDeltaX !== undefined) {
                    this.maxDeltaX = this.config.maxDeltaX;
                }
                if (this.config.maxDeltaY !== undefined) {
                    this.maxDeltaY = this.config.maxDeltaY;
                }
                if (this.config.maxDist !== undefined) {
                    this.maxDistSq = this.config.maxDist * this.config.maxDist;
                }
                if (this.config.minPointers !== undefined) {
                    this.minNumberOfPointers = this.config.minPointers;
                }
            }
        },
        {
            key: "resetConfig",
            value: function resetConfig() {
                _get(_get_prototype_of(TapGestureHandler.prototype), "resetConfig", this).call(this);
                this.maxDeltaX = Number.MIN_SAFE_INTEGER;
                this.maxDeltaY = Number.MIN_SAFE_INTEGER;
                this.maxDistSq = Number.MIN_SAFE_INTEGER;
                this.maxDurationMs = DEFAULT_MAX_DURATION_MS;
                this.maxDelayMs = DEFAULT_MAX_DELAY_MS;
                this.numberOfTaps = DEFAULT_NUMBER_OF_TAPS;
                this.minNumberOfPointers = DEFAULT_MIN_NUMBER_OF_POINTERS;
            }
        },
        {
            key: "clearTimeouts",
            value: function clearTimeouts() {
                clearTimeout(this.waitTimeout);
                clearTimeout(this.delayTimeout);
            }
        },
        {
            key: "startTap",
            value: function startTap() {
                var _this = this;
                this.clearTimeouts();
                this.waitTimeout = setTimeout(function() {
                    return _this.fail();
                }, this.maxDurationMs);
            }
        },
        {
            key: "endTap",
            value: function endTap() {
                var _this = this;
                this.clearTimeouts();
                if (++this.tapsSoFar === this.numberOfTaps && this.currentMaxNumberOfPointers >= this.minNumberOfPointers) {
                    this.activate();
                } else {
                    this.delayTimeout = setTimeout(function() {
                        return _this.fail();
                    }, this.maxDelayMs);
                }
            }
        },
        {
            key: "onPointerDown",
            value: //Handling Events
            function onPointerDown(event) {
                this.tracker.addToTracker(event);
                _get(_get_prototype_of(TapGestureHandler.prototype), "onPointerDown", this).call(this, event);
                this.trySettingPosition(event);
                this.startX = event.x;
                this.startY = event.y;
                this.lastX = event.x;
                this.lastY = event.y;
                this.updateState(event);
            }
        },
        {
            key: "onPointerAdd",
            value: function onPointerAdd(event) {
                _get(_get_prototype_of(TapGestureHandler.prototype), "onPointerAdd", this).call(this, event);
                this.tracker.addToTracker(event);
                this.trySettingPosition(event);
                this.offsetX += this.lastX - this.startX;
                this.offsetY += this.lastY - this.startY;
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.startX = this.tracker.getLastAvgX();
                this.startY = this.tracker.getLastAvgY();
                this.updateState(event);
            }
        },
        {
            key: "onPointerUp",
            value: function onPointerUp(event) {
                _get(_get_prototype_of(TapGestureHandler.prototype), "onPointerUp", this).call(this, event);
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.tracker.removeFromTracker(event.pointerId);
                this.updateState(event);
            }
        },
        {
            key: "onPointerRemove",
            value: function onPointerRemove(event) {
                _get(_get_prototype_of(TapGestureHandler.prototype), "onPointerRemove", this).call(this, event);
                this.tracker.removeFromTracker(event.pointerId);
                this.offsetX += this.lastX - this.startX;
                this.offsetY += this.lastY = this.startY;
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.startX = this.lastX;
                this.startY = this.lastY;
                this.updateState(event);
            }
        },
        {
            key: "onPointerMove",
            value: function onPointerMove(event) {
                this.trySettingPosition(event);
                this.tracker.track(event);
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.updateState(event);
                _get(_get_prototype_of(TapGestureHandler.prototype), "onPointerMove", this).call(this, event);
            }
        },
        {
            key: "onPointerOutOfBounds",
            value: function onPointerOutOfBounds(event) {
                this.trySettingPosition(event);
                this.tracker.track(event);
                this.lastX = this.tracker.getLastAvgX();
                this.lastY = this.tracker.getLastAvgY();
                this.updateState(event);
                _get(_get_prototype_of(TapGestureHandler.prototype), "onPointerOutOfBounds", this).call(this, event);
            }
        },
        {
            key: "updateState",
            value: function updateState(event) {
                if (this.currentMaxNumberOfPointers < this.tracker.getTrackedPointersCount()) {
                    this.currentMaxNumberOfPointers = this.tracker.getTrackedPointersCount();
                }
                if (this.shouldFail()) {
                    this.fail();
                    return;
                }
                switch(this.currentState){
                    case State.UNDETERMINED:
                        if (event.eventType === EventTypes.DOWN) {
                            this.begin();
                        }
                        this.startTap();
                        break;
                    case State.BEGAN:
                        if (event.eventType === EventTypes.UP) {
                            this.endTap();
                        }
                        if (event.eventType === EventTypes.DOWN) {
                            this.startTap();
                        }
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "trySettingPosition",
            value: function trySettingPosition(event) {
                if (this.currentState !== State.UNDETERMINED) {
                    return;
                }
                this.offsetX = 0;
                this.offsetY = 0;
                this.startX = event.x;
                this.startY = event.y;
            }
        },
        {
            key: "shouldFail",
            value: function shouldFail() {
                var dx = this.lastX - this.startX + this.offsetX;
                if (this.maxDeltaX !== Number.MIN_SAFE_INTEGER && Math.abs(dx) > this.maxDeltaX) {
                    return true;
                }
                var dy = this.lastY - this.startY + this.offsetY;
                if (this.maxDeltaY !== Number.MIN_SAFE_INTEGER && Math.abs(dy) > this.maxDeltaY) {
                    return true;
                }
                var distSq = dy * dy + dx * dx;
                return this.maxDistSq !== Number.MIN_SAFE_INTEGER && distSq > this.maxDistSq;
            }
        },
        {
            key: "activate",
            value: function activate() {
                _get(_get_prototype_of(TapGestureHandler.prototype), "activate", this).call(this);
                this.end();
            }
        },
        {
            key: "onCancel",
            value: function onCancel() {
                this.resetProgress();
                this.clearTimeouts();
            }
        },
        {
            key: "resetProgress",
            value: function resetProgress() {
                this.clearTimeouts();
                this.tapsSoFar = 0;
                this.currentMaxNumberOfPointers = 0;
            }
        }
    ]);
    return TapGestureHandler;
}(GestureHandler);
export { TapGestureHandler as default };
